import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-368c1702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "withholding-finished" }
const _hoisted_2 = { class: "px-3 pb-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caution" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "text-size-16" }, [
    /*#__PURE__*/_createElementVNode("li", null, "\n              給与は申請が事業所に承認されたタイミングでウォレットに反映されます\n            "),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("li", null, "\n              数日経っても承認されない場合は事業所にチャットメッセージで連絡してください\n            ")
  ])
], -1))
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "summary-area" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "my-4 text-weight-500" }, "\n            勤怠変更申請が完了しました！\n          ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Balloon = _resolveComponent("Balloon")!
  const _component_AppButtonOutline = _resolveComponent("AppButtonOutline")!
  const _component_RecentOrdersWithRecommendText = _resolveComponent("RecentOrdersWithRecommendText")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      default: _withCtx(() => [
        _createTextVNode("\n      勤怠変更申請完了\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Balloon)
          ]),
          _createTextVNode(),
          _hoisted_6
        ]),
        _createTextVNode(),
        _createVNode(_component_AppButtonOutline, {
          to: { name: 'ApplicationsList' },
          block: true,
          class: "d-block"
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n          仕事管理に戻る\n        ")
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _createVNode(_component_RecentOrdersWithRecommendText, {
          class: "mt-4",
          currentOrder: _ctx.order,
          orders: _ctx.orders,
          applicableOrderCount: _ctx.applicableOrderCount
        }, null, 8, ["currentOrder", "orders", "applicableOrderCount"])
      ])
    ]),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}